/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const deRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Antrag, um eine Schule hinzuzufügen',
    description: 'Bitte füllen Sie das Formular unten aus. Nicht alle Schulen, die sich bewerben, werden garantiert hinzugefügt, aber alle Anträge werden von SheerID recherchiert und berücksichtigt. ',
    noCountry: 'Sehen Sie das Land Ihrer Schule nicht? Sie sind nicht für dieses Angebot qualifiziert.',
    searchByOrgName: 'Sehen Sie Ihre Schule nicht? Suche nach Namen',
    completeRequest: 'Sehen Sie Ihre Schule weder in der Liste der qualifizierten noch der nicht qualifizierten Schulen? Vervollständigen Sie Ihre Anfrage',
    submit: 'Senden',
    eligibleOrgs: 'Qualifizierte Schulen. Klicken Sie auf das Symbol, um den Namen zu kopieren, und kehren Sie dann zum Bestätigungsformular zurück.',
    ineligibleOrgs: 'Nicht qualifizierte Schulen. Es tut uns leid, aber Schüler dieser Schulen sind für dieses Angebot nicht qualifiziert.',
    none: 'Keine',
    country: 'Wo gehen Sie zur Schule?',
    changeLanguage: 'Sprache ändern',
    copied: 'Kopiert',
    firstName: 'Vorname',
    lastName: 'Nachname',
    emailAddress: 'E-Mailadresse',
    poweredBy: 'Verifizierungs-Services unterstützt von SheerID.',
    fields: {
        countryPlaceholder: 'Land auswählen',
        domainLabel: 'Webseite der Schule',
        domainPlaceholder: 'meineschule.edu',
        orgNameLabel: 'Name der Schule',
        orgNamePlaceholder: 'Meine Schule',
    },
    step: {
        success: {
            title: 'Vielen Dank',
            description: 'Wir haben Ihre Anfrage erhalten, eine Bildungseinrichtung hinzuzufügen. Bitte beachten Sie, dass die Bearbeitung Ihrer Anfrage bis zu sieben Tage in Anspruch nehmen kann. Außerdem kann eine Aufnahme in die Liste der berechtigten Bildungseinrichtungen nicht garantiert werden.<br><br>Sie können sich in der Zwischenzeit gern über andere Abonnementoptionen informieren.',
        },
        error: {
            title: 'Ein unerwarteter Fehler ist aufgetreten',
            description: 'Es tut uns leid, aber wir können Ihren Antrag nicht bearbeiten. Bitte versuchen Sie es später noch einmal.',
            seeingProblem: 'Falls dieses Problem weiterhin auftritt,',
            contactUs: 'setzen Sie sich bitte mit uns in Verbindung',
        },
    },
    errorId: {
        invalidCountry: 'Dieses Feld ist erforderlich',
        invalidEmail: 'Ungültige E-Mailadresse',
        invalidFirstName: 'Ungültiger Vorname',
        invalidLastName: 'Ungültiger Nachname',
        requiredField: 'Dieses Feld ist erforderlich',
        invalidField: 'Dieses Feld ist ungültig',
        invalidUrl: 'Ungültige URL',
        tooManyResults: 'Ihre Suche ergab zu viele Ergebnisse, bitte verfeinern Sie Ihre Suche und versuchen Sie es erneut',
    },
    faq: 'SheerID FAQs für Schulaufnahmen-Anfrage',
    countries: {
        AD: 'Andorra',
        AE: 'Vereinigte Arabische Emirate',
        AF: 'Afghanistan',
        AG: 'Antigua und Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AN: 'Niederländische Antillen',
        AO: 'Angola',
        AR: 'Argentinien',
        AS: 'Amerikanischen Samoa-Inseln',
        AT: 'Österreich',
        AU: 'Australien',
        AW: 'Aruba',
        AZ: 'Aserbaidschan',
        BA: 'Bosnien-Herzegowina',
        BB: 'Barbados',
        BD: 'Bangladesch',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivien',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Weißrussland',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Demokratische Republik Kongo',
        CF: 'Zentralafrikanische Republik',
        CG: 'Kongo',
        CH: 'Schweiz',
        CI: 'Elfenbeinküste (Elfenbeinküste)',
        CK: 'Cookinseln',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'China',
        CO: 'Kolumbien',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Kap Verde',
        CY: 'Zypern',
        CZ: 'Tschechische Republik',
        DE: 'Deutsch',
        DJ: 'Dschibuti',
        DK: 'Dänemark',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DZ: 'Algerien',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Ägypten',
        EH: 'Westsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: 'Äthiopien',
        FI: 'Finnland',
        FJ: 'Fidschi',
        FK: 'Falkland Inseln',
        FM: 'Mikronesien',
        FO: 'Färöer Inseln',
        FR: 'Frankreich',
        GA: 'Gabun',
        GB: 'Vereinigtes Königreich',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Französisch',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grönland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (Französisch)',
        GQ: 'Äquatorialguinea',
        GR: 'Griechenland',
        GS: 'Südgeorgien und Südliche Sandwichinseln',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Gehörte und McDonald Islands',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IN: 'Indien',
        IO: 'Britisches Territorium des Indischen Ozeans',
        IQ: 'Irak',
        IR: 'Ich rannte',
        IS: 'Island',
        IT: 'Italien',
        JM: 'Jamaika',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KH: 'Kambodscha',
        KI: 'Kiribati',
        KM: 'Komoren',
        KN: 'St. Kitts & Nevis Anguilla',
        KP: 'Nord Korea',
        KR: 'Südkorea',
        KW: 'Kuwait',
        KY: 'Cayman Inseln',
        KZ: 'Kasachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'St. Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        LY: 'Libyen',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldau',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshallinseln',
        MK: 'Mazedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolei',
        MO: 'Macau',
        MP: 'Nördliche Marianneninseln',
        MQ: 'Martinique (Französisch)',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediven',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malaysia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Neukaledonien (Französisch)',
        NE: 'Niger',
        NF: 'Norfolkinsel',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        NO: 'Norwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Neuseeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesien (Französisch)',
        PG: 'Papua Neu-Guinea',
        PH: 'Philippinen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre und Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PS: 'Palästina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Wiedersehen (Französisch)',
        RO: 'Rumänien',
        RS: 'Serbien',
        RU: 'Russische Föderation',
        RW: 'Ruanda',
        SA: 'Saudi Arabien',
        SB: 'Salomon-Inseln',
        SC: 'Seychellen',
        SD: 'Sudan',
        SE: 'Schweden',
        SG: 'Singapur',
        SH: 'Heilige Helena',
        SI: 'Slowenien',
        SK: 'Slowakische Republik',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'Südsudan',
        ST: 'Saint Tome (Sao Tome) und Principe',
        SV: 'El Salvador',
        SY: 'Syrien',
        SZ: 'Swasiland',
        TC: 'Turks- und Caicosinseln',
        TD: 'Tschad',
        TF: 'Südfranzösische Territorien',
        TG: 'Gehen',
        TH: 'Thailand',
        TJ: 'Tadschikistan',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistan',
        TN: 'Tunesien',
        TO: 'Tonga',
        TR: 'Truthahn',
        TT: 'Trinidad und Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tansania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'Vereinigte Staaten',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Staat der Vatikanstadt',
        VC: 'St. Vincent & Grenadinen',
        VE: 'Venezuela',
        VG: 'Virgin Inseln, Britisch)',
        VI: 'Jungferninseln (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis und Futuna Inseln',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Südafrika',
        ZM: 'Sambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'Arabisch',
        bg: 'bulgarisch',
        cs: 'Tschechisch',
        da: 'dänisch',
        de: 'Deutsch',
        el: 'griechisch',
        'en-GB': 'Englisch',
        'en-US': 'Englisch',
        'es-ES': 'Spanisch (latam)',
        es: 'Spanisch',
        fi: 'finnisch',
        'fr-CA': 'Franko Kanadier)',
        fr: 'Französisch',
        hr: 'kroatisch',
        hu: 'Ungarisch',
        id: 'Indonesisch',
        is: 'isländisch',
        it: 'Italienisch',
        iw: 'Hebräisch',
        ja: 'japanisch',
        ko: 'Koreanisch',
        lt: 'litauisch',
        ms: 'malaiisch',
        nl: 'Niederländisch',
        no: 'norwegisch',
        pl: 'Polnisch',
        'pt-BR': 'Portugiesisch',
        pt: 'Portugiesisch',
        ro: 'rumänisch',
        ru: 'Russisch',
        sk: 'slowakisch',
        sl: 'Slowenisch',
        sr: 'serbisch',
        sv: 'Schwedisch',
        tr: 'Türkisch',
        'zh-HK': 'Chinesisch (Hong Kong)',
        zh: 'Chinesische Tradition)',
    },
};
